var summaryModule = function (_app, _estimateShippingPostcode, _globalSettings) {

    var PromoCodeView = Backbone.View.extend({

        events: {
            'click @summaryPromoCodeApply': 'onApply',
            'paste @summaryPromoCodeValue': 'onChangePromoCode',
            'keyup @summaryPromoCodeValue': 'onChangePromoCode',
            'mouseup @summaryPromoCodeValue': 'onChangePromoCode'
        },

        initialize: function () {
            _.bindAll(this, 'clean');
            this._$input = this.$el.find('@summaryPromoCodeValue');
            this.$label = this.$el.find('@summaryInputLabel');
            this._$applyButton = this.$el.find('@summaryPromoCodeApply').hide();
        },

        onChangePromoCode: function (e) {
            setTimeout(_.bind(function () {
                if (e && e.currentTarget.value || this._$input.val()) {
                    this._$applyButton.show();
                    this.$label.css('visibility', 'hidden');
                } else {
                    this._$applyButton.hide();
                    this.$label.css('visibility', '');
                }

            }, this), 0);
        },

        onApply: function (e) {
            e.preventDefault();
            var value = this._$input.val();
            value && _app.event && _app.event.applyVoucher();
            value && _app.checkout.addAndApplyVoucherByKey(value).done(this.clean);
        },

        clean: function () {
            this._$input.val('');
            this.onChangePromoCode();
        },

        focus: function () {
            this._$input.focus();
        }
    });

    var VoucherItemView = Backbone.View.extend({
        className: 'gift-voucher-coupon__small',
        events: {
            'click': 'onClick'
        },

        initialize: function (opts) {
            _.bindAll(this);
            this.listenTo(this.model, 'remove', this.remove);
            this.listenTo(this.model, 'change', this.render);
        },

        onClick: function (e) {
            e.preventDefault();
            this.model.apply();
        },

        render: function () {
            this.$el.html($.tmpl('bt-checkout-summary-voucher-item', this.model.toJSON()));
            this.$el.toggleClass('gift-voucher-coupon__small-applied', this.model.get('IsApplied') === true);
            return this;
        }
    });

    var PromocodeItemView = Backbone.View.extend({
        className: 'promocodes__small',
        events: {
            'click @removePromocode': 'onClick'
        },

        initialize: function (opts) {
            _.bindAll(this);
            this.listenTo(this.model, 'remove', this.remove);
        },

        onClick: function (e) {
            var data = this.model.toJSON();
            e.preventDefault();
            data.Code && _app.checkout.removeVoucherByKey(data.Code);
        },

        render: function () {
            var data = this.model.toJSON();
            if (data.Amount) {
                data.AmountStr = window.toMoney(data.Amount, GlobalSettings.CurrencySign);
            }
            this.$el.html($.tmpl('bt-checkout-summary-promocode-item', data));
            return this;
        }
    });

    var VouchersView = Backbone.View.extend({
        className: 'voucher-block',
        hiddenClass: 'hidden',
        events: {
            'click @promocodeToggleButton': 'togglePromocode',
            'click @promocodeHideButton': 'togglePromocode',
            'click @promocodeOpenLoginForm': '_openLoginForm'
        },
        initialize: function (opts) {
            _.bindAll(this);

            opts = opts || {};
            this.VoucherItemView = opts.VoucherItemView || VoucherItemView;
            this.PromoCodeView = opts.PromoCodeView || PromoCodeView;
            this.listenTo(this.collection, 'add', this.onAddItem);
            this.listenTo(this.collection, 'remove', this.toggleEmpty);

            this.listenTo(app.models.promocodes, 'add', this.onAddPromocode);
            app.checkout.onUpdate(this._update);
        },

        _openLoginForm: function() {
            window.landingForm && landingForm.showPopup({ closeBtn: true, mode: landingForm.mode.Login, message: "Sign in to view your vouchers or use promocode" });
        },

        togglePromocode: function () {
            this.$promoCode.toggleClass(this.hiddenClass);
            this.$promocodeToggleButton.toggleClass(this.hiddenClass);
            this.promoCodeView.focus();
        },

        toggleEmpty: function () {
            var isEmpty = !this.collection.length && !app.models.promocodes.length;
            if (isEmpty) {
                this.$voucherListContainer.addClass(this.hiddenClass);
                this.$voucherList.html('');
            } else {
                this.$voucherListContainer.removeClass(this.hiddenClass);
            }
            return isEmpty;
        },

        _update: function() {
            var isAuth = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
            this.$('@promocodeToggleButton').toggleClass('hidden-block', !isAuth);
            this.$('@promocodeOpenLoginForm').toggleClass('hidden-block', isAuth);
        },

        render: function () {
            var totalDiscountLeft = 0;
            this.collection.each(function (v) { totalDiscountLeft += v.DiscountLeft });
            this.$el.html($.tmpl('bt-checkout-summary-vouchers', { TotalPriceWithVouchers: totalDiscountLeft, IsAuthorized: window.__isAuthorized__ }));
            this.$voucherList = this.$el.find('@voucherList');
            this.$promocodeList = this.$el.find('@promocodeList');
            this.$voucherListContainer = this.$el.find('@voucherListContainer');
            this.$promocodeToggleButton = this.$el.find('@promocodeToggleButton');
            this.$promoCode = this.$el.find('@summaryPromoCode').addClass(this.hiddenClass);

            this.renderVouchers();
            this.renderPromoCode();
            this.renderPromocodesList();
            return this;
        },

        renderPromoCode: function () {
            this.promoCodeView = new this.PromoCodeView({
                el: this.$promoCode
            });
        },

        renderVouchers: function () {
            if (this.toggleEmpty()) {
                return;
            }

            var rendered = [];
            this.collection.each(_.bind(function (m) {
                var view = new this.VoucherItemView({
                    model: m
                }).render();
                rendered.push(view.el);
            }, this));
            this.$voucherList.html(rendered);

            return this;
        },

        renderPromocodesList: function () {
            var rendered = [];
            app.models.promocodes.each(_.bind(function (m) {
                var view = new PromocodeItemView({
                    model: m
                }).render();
                rendered.push(view.el);
            }, this));
            this.$promocodeList.html(rendered);

            return this;
        },

        onAddItem: function (m) {
            var view = new this.VoucherItemView({
                model: m
            }).render();
            this.$voucherList.append(view.el);
        },

        onAddPromocode: function (m) {
            var view = new PromocodeItemView({
                model: m
            }).render();
            this.$promocodeList.append(view.el);
        }
    });

    var FreeShippingView = Backbone.View.extend({
        el: '@freeShippingContainer',
        initialize: function () {
            _.bindAll(this);
            this.listenTo(this.model.summary, 'change', this.render);
        },
        render: function () {
            var amountToFreeDelivery = this.model.summary.get('AmountToFreeDelivery');
            var delivery = this.model.summary.get('Delivery');
            var hasNoShipments = this.model.shipmentList.length === 0;

            var html = '';
            if (delivery > 0 && amountToFreeDelivery > 0 && hasNoShipments) {
                html = $.tmpl('bt-checkout-free-shipping',
                    {
                        Value: window.toMoney(amountToFreeDelivery, _globalSettings.CurrencySign)
                    }
                );
            }

            this.$el.html(html);

            return this;
        }
    });

    var freeShippingView = new FreeShippingView({
        model: _app.models
    }).render();

    var SummeryDeliveryView = Backbone.View.extend({
        events: {
            'click @estimateFormBtn': '_focusEstimateForm',
            'click @summaryDeliveryPostfixPostcode': '_focusEstimateForm'
        },

        className: 'summary-row clearfix',

        initialize: function () {
            _.bindAll(this, '_render', '_getDeliveryValue', '_postcodeChanged');

            this.listenTo(this.model, 'change', this._render);
            _app.models.shipmentList.on('add', this._render);
            _estimateShippingPostcode.on(this._postcodeChanged);
            this._render();

        },

        _postcodeChanged: function () {
            var settings = CheckoutSettings.getBasketSettings();
            var estimateShipmentPostcode = this.model.get('EstimateShipmentPostcode');
            var postcode = estimateShipmentPostcode || '';// _estimateShippingPostcode.get();
            if (settings.ShippingByPostcodeEnabled === true && postcode) {
                this.$('@summaryDeliveryPostfix').removeClass('hidden-block');
                this.$('@summaryDeliveryPostfixPostcode').text(postcode);
            }
        },

        _render: function () {
            var _deliveryValue = this._getDeliveryValue();
            var shippingAvailability = _app.models.shipmentList.shippingAvailability();

            //var deliveryEstimate = this.model.get('DeliveryEstimate');
            this.$el.html($.tmpl('bt-checkout-summary-delivery-row', {
                Name: GetPageTemplate('_TotalsShipping'),
                Value: _deliveryValue,
                Role: 'summaryDelivery'.sub(),
                ShippingAvailability: shippingAvailability
            }));

            this.$estimate = this.$('@estimateFormBtn');
            this.$estimate.toggleClass('hidden-block', !!_deliveryValue);
            this._postcodeChanged();
        },

        _focusEstimateForm: function () {
            $('@estimatePostcode').focus();
        },

        _getDeliveryValue: function () {
            var delivery = this.model.get('Delivery');
            if (delivery === null) {
                return '';
            }
            return delivery !== 0
                ? window.toMoney(this.model.get('Delivery'), _globalSettings.CurrencySign)
                : $.tmpl('bt-checkout-summary-row-free-delivery').html();
        }
    });

    var SummaryView = Backbone.View.extend({
        el: '@summaryContent',

        initialize: function (opts) {
            opts = opts || {};
            _.bindAll(this);

            this.vouchersView = new (opts.VouchersView || VouchersView)({
                collection: _app.models.vouchers
            });

            this.listenTo(this.model, 'change', this.updateSummary);

        },

        render: function () {
            var rendered = [];
            var _deliveryValue = this._getDeliveryValue();

            // Render rows.
            rendered.push($.tmpl('bt-checkout-summary-row', {
                Name: GetPageTemplate('_TotalsSubtotal'),
                Value: window.toMoney(this.model.get('Subtotal'), _globalSettings.CurrencySign),
                Role: 'summarySubtotal'
            }));

            var deliveryView = new SummeryDeliveryView({ model: this.model });

            rendered.push(deliveryView.el);

            if (this.model.isDisplayTax()) {
                rendered.push($.tmpl('bt-checkout-summary-row', {
                    Name: GetPageTemplate('_TotalsTax'),
                    Value: window.toMoney(this.model.get('Tax'), _globalSettings.CurrencySign),
                    Role: 'summaryTax'
                }));
            }

            rendered.push($.tmpl('bt-checkout-summary-row-select',
                {
                    Value: window.toMoney(this.model.get('Select'), _globalSettings.CurrencySign)
                }));

            var prefix = this.model.get('Discount') > 0 ? '- ' : '';
            var discountValue = prefix + window.toMoney(this.model.get('Discount'), _globalSettings.CurrencySign);

            rendered.push($.tmpl('bt-checkout-summary-discount-row', {
                Name: 'Discount',
                Value: discountValue,
                Role: 'summaryVouchers'
            }));



            if (this._selectSummaryExists()) {
                rendered.push($.tmpl('bt-checkout-summary-row-total',
                    {
                        Value: window.toMoney(this.model.get('TotalWithSelect'), _globalSettings.CurrencySign),
                        exShipping: !_deliveryValue
                    }));
            } else {
                rendered.push($.tmpl('bt-checkout-summary-row-total',
                    {
                        Value: window.toMoney(this.model.get('Total'), _globalSettings.CurrencySign),
                        exShipping: !_deliveryValue
                    }));
            }

            rendered.push(this.vouchersView.render().el);

            this.$el.html(rendered);

            this.$subtotal = this.$el.find('@summarySubtotal');
            //this.$delivery = this.$el.find('@summaryDelivery');
            this.$tax = this.$el.find('@summaryTax');
            this.$vouchers = this.$el.find('@summaryVouchers');
            this.$total_title = this.$el.find('@summaryTotalField_title');
            this.$total_value = this.$el.find('@summaryTotalField_value');

            this.$select_value = this.$el.find('@summarySelectField_value');
            this.$select = this.$el.find('@summarySelect');

            this._updateTotalTitle();
            this._updateClasses();
            this.listenTo(_app.models.currentMethod, 'change', this._updateClasses);
            this.listenTo(_app.models.ourpay, 'update', this._updateClasses);

            return this;
        },

        _updateTotalTitle: function () {
            var _deliveryValue = this._getDeliveryValue();
            var text = GetPageTemplate('_TotalOrder');
            if (!_deliveryValue) text += ' (excl. shipping)';
            this.$total_title.text(text);
        },

        updateSummary: function () {
            this.$subtotal.text(window.toMoney(this.model.get('Subtotal'), _globalSettings.CurrencySign));
            //this.$delivery.html(this._getDeliveryValue());
            this.$tax.text(window.toMoney(this.model.get('Tax'), _globalSettings.CurrencySign));
            this.$vouchers.text(window.toMoney(this.model.get('Discount'), _globalSettings.CurrencySign));

            if (this._selectSummaryExists()) {
                this.$select_value.text(window.toMoney(this.model.get('Select'), _globalSettings.CurrencySign));
                this.$total_value.text(window.toMoney(this.model.get('TotalWithSelect'), _globalSettings.CurrencySign));
            } else {
                this.$total_value.text(window.toMoney(this.model.get('Total'), _globalSettings.CurrencySign));
            }
            this._updateTotalTitle();
        },

        _updateClasses: function () {
            var isOurpay = _app.models.ourpay.displayAlone();
            this.$total_title.toggleClass('summary-row_title__total', !isOurpay);
            this.$total_value.toggleClass('summary-row_value__total', !isOurpay);

            this.$select.toggle(this._selectSummaryExists());

        },

        _selectSummaryExists: function () {
            return this.model && !!this.model.get('Select');
        },

        _getDeliveryValue: function () {
            var delivery = this.model.get('Delivery');
            if (delivery === null) {
                return '';
            }
            return delivery !== 0
                ? window.toMoney(this.model.get('Delivery'), _globalSettings.CurrencySign)
                : $.tmpl('bt-checkout-summary-row-free-delivery').html();
        }
    });

    var summaryView = new SummaryView({
        model: _app.models.summary
    }).render();
};